import { useState, useEffect } from 'react';
import { useAlert } from '../../context/AlertContext';

// Hooks
import { useCompetitions } from '../../hooks/useCompetitions';
import { useCompetitionEvents } from '../../hooks/useCompetitionEvents';
import { useMemberOptions } from '../../hooks/useMemberOptions';
import { useTeamIndex } from '../../hooks/useTeamIndex';

// src/pages/AdminDashboard.js
export default function AdminDashboard({step, setStep}) {
  const { showAlert } = useAlert();

  // Competition data
  const competitions = useCompetitions();
  const [selectedCompetition, setSelectedCompetition] = useState(null);
  const competitionDates = useCompetitionEvents(selectedCompetition)
  const [selectedDate, setSelectedDate] = useState(null);

  // Fetch teams when in index view
  const teamIndexList = useTeamIndex(
    selectedCompetition?.name,
    selectedDate,
    step,
  );


  // Initialize default competition
  useEffect(() => {
    if (competitions.length) {
      setSelectedCompetition(competitions[0]);
    }
  }, [competitions]);

  useEffect(() => {
    if (selectedCompetition) {
      setSelectedDate(competitionDates[0])
    }
  }, [competitionDates])


  const goToNext = () => {
    if (!selectedCompetition) {
      showAlert(['Select a competition first.'], 'error');
      return;
    }
    setStep(selectedCompetition.division_split ? 1 : 2);
  };

  const createTeam = async (address) => {
    return 
  };

  return (
    <main className="max-w-screen min-h-screen flex flex-col items-center justify-center md:px-8">
      Admin Dashboard
    </main>
  );
}
